<template>
    <div class="wrapper">
        <v-head></v-head>
        <router-view></router-view>
    </div>
</template>

<script>
    import vHead from '@/components/home/common/header.vue';
    export default {
        components:{
            vHead
        }
    }
</script>
